// extracted by mini-css-extract-plugin
module.exports = {"NavElements":"NavElements_NavElements__suXcc"};